type BrandMarkProps = {
  className?: string;
  variant?: "mark" | "full";
};

export function BrandMark({ className = "", variant = "mark" }: BrandMarkProps) {
  return (
    <span className={`brand-mark brand-mark--${variant} ${className}`.trim()} role="img" aria-label="Kils OK">
      <img
        src={variant === "full" ? "/images/kilsok_logo_new_liggande.png" : "/images/kilsok_logo_new.png"}
        alt=""
      />
    </span>
  );
}
